import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ToastService } from '../../Core/services/toast.service';
import { AuthenticationService } from '../../Core/services/authentication.service';
import { StorageService } from '../../Core/services/storage.service';
import { ApiService } from '../../Core/services/api.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-menu',
  imports: [CommonModule, RouterModule, NgSelectModule, FormsModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent implements OnInit {
  @Output() menuToggled = new EventEmitter<boolean>();
  isCollapsed = signal(false);
  lastName: any;
  firstName: any;
  showChilds = [];

  menuItems = [
    // { name: 'DASHBOARD', path: '/dashboard', icon: '/assets/icons/dashboard (quantrol).svg' },
    // { name: 'MASTER REPORT', path: '/master-reporting', icon: '/assets/icons/order manager 1.svg' },
    // { name: 'DASHBOARD', requiredRoles: ['OWNER', 'MASTER_ADMIN', 'SUPER_ADMIN', 'ORM_ADMIN', 'ADMIN', 'AGENT'], childs: [], path: '/dashboard', icon: '/assets/icons/dashboard grey (quantrol.io).svg', selectedIcon: '/assets/icons/Expenses grey (quantrol.io).svg', showChilds: false, },
    // { name: 'MASTER REPORT', requiredRoles: ['OWNER', 'MASTER_ADMIN', 'SUPER_ADMIN', 'ORM_ADMIN', 'ADMIN', 'AGENT'], childs: [{ name: 'General', path: '/general', requiredRoles: ['OWNER', 'MASTER_ADMIN', 'SUPER_ADMIN', 'CRM_ADMIN', 'ADMIN', 'AGENT'] }, { name: 'Inhouse', path: '/inhouse', requiredRoles: ['OWNER', 'MASTER_ADMIN', 'SUPER_ADMIN', 'CRM_ADMIN', 'ADMIN', 'AGENT'] }, { name: 'Test', path: '/test', requiredRoles: ['OWNER', 'MASTER_ADMIN', 'SUPER_ADMIN', 'CRM_ADMIN', 'ADMIN', 'AGENT'] }, { name: 'Rebook', path: '/rebook', requiredRoles: ['OWNER', 'MASTER_ADMIN', 'SUPER_ADMIN', 'CRM_ADMIN', 'ADMIN', 'AGENT'] }], path: '/master-report', icon: '/assets/icons/master report grey (quantrol.io).svg', showChilds: false, selectedIcon: '/assets/icons/master report grey (quantrol.io).svg' },
    { name: 'Advance CRM', requiredRoles: ['OWNER', 'MASTER_ADMIN', 'SUPER_ADMIN', 'CRM_ADMIN', 'ADMIN', 'AGENT'], childs: [{ name: 'General', path: '/general', requiredRoles: ['OWNER', 'MASTER_ADMIN', 'SUPER_ADMIN', 'CRM_ADMIN', 'ADMIN', 'AGENT'] }, { name: 'Inhouse', path: '/inhouse', requiredRoles: ['OWNER', 'MASTER_ADMIN', 'SUPER_ADMIN', 'CRM_ADMIN', 'ADMIN'] }, { name: 'Agents', path: '/agent', requiredRoles: ['OWNER', 'MASTER_ADMIN', 'SUPER_ADMIN', 'CRM_ADMIN', 'ADMIN'] }, { name: 'Test', path: '/test', requiredRoles: ['OWNER', 'MASTER_ADMIN', 'SUPER_ADMIN', 'CRM_ADMIN', 'ADMIN'] }], path: '/crm', icon: '/assets/icons/expense grey (quantrol.io).svg', showChilds: false, selectedIcon: '/assets/icons/Expenses grey (quantrol.io).svg' },
    { name: 'Expenses', requiredRoles: ['OWNER'], childs: [], path: '/expenses', icon: '/assets/icons/Expenses grey (quantrol.io).svg', selectedIcon: '/assets/icons/Expenses grey (quantrol.io).svg', showChilds: false, },
    // { name: 'Support', path: '/support', icon: '/assets/icons/expense (black).svg', selectedIcon: '/assets/icons/expense (white).svg' },
  ];
  tenants: any;
  selectedTenant: any;

  constructor(private _route: Router, private _toast: ToastService, private authService: AuthenticationService, private storageService: StorageService, private apiService : ApiService) {
    let userData = this.authService.getData();
    this.lastName = userData.lastName;
    this.firstName = userData.firstName;
  }

  ngOnInit() {
    this.showChilds = this.storageService.getOpenChilds() || [];
    if (this.showChilds.length > 0) {
      this.showChilds.forEach(index => {
        this.menuItems[index].showChilds = true;
      });
    }
    // if(['OWNER','MASTER_ADMIN'].includes(this.storageService.getUserRoles())) this.getTenants();
  }

  changeTenant(event:any) {
    this.storageService.setTenantKey(this.selectedTenant)
  }

  getTenants() {
    this.apiService.getAllTenants().subscribe((res:any) => {
      this.tenants = res.data
      this.tenants.forEach((tenant:any) => {
        if(tenant.companyName == 'Rateloc') {
          this.selectedTenant = tenant.tenantKey;
        }
      });
    });
  }

  toggleMenu() {
    this.isCollapsed.set(!this.isCollapsed());
    this.menuToggled.emit(this.isCollapsed());
  }

  hasPermission(requiredRoles: string[]): boolean {
    return requiredRoles.some(role => this.authService.hasRole(role));
  }

  toggleChilds(index) {
    this.menuItems[index].showChilds = !this.menuItems[index].showChilds;
    if(this.menuItems[index].showChilds) this.showChilds.push(index)
    if(!this.menuItems[index].showChilds) this.showChilds.splice(index,1)
    this.storageService.setOpenChilds(this.showChilds);
  }

  logout() {
    this._toast.showSuccess("Logout Successful")
    this.authService.logout();
    localStorage.clear();
    sessionStorage.clear();
    this._route.navigate(['/']);
  }
}
